import React from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import styles from './index.module.scss';

type LearnMoreModalProps = {
  buyerDisplayPrice: string;
  sellerDisplayPrice: string;
  modalDialogTitleId: string;
};

const LearnMoreModal: React.FC<LearnMoreModalProps> = ({
  buyerDisplayPrice,
  sellerDisplayPrice,
  modalDialogTitleId,
}) => {
  const { t } = useTranslation('pricing-calculator');
  return (
    <div className={styles.learnMore}>
      <div
        className={styles.learnMore__title}
        id={modalDialogTitleId}
      >
        {t('PRICING_CALCULATOR.INFO.TITLE')}
      </div>
      <p className={styles.learnMore__firstListing}>{t('PRICING_CALCULATOR.INFO.COMMISSION.FIRST_LISTING')}</p>
      <p className={clsx(styles.learnMore__intro, 'vc-text-m')}>{t('PRICING_CALCULATOR.INFO.INTRO')}</p>
      <section className={styles.learnMore__section}>
        <div
          className={clsx(
            styles.learnMore__section__title,
            styles['learnMore__section__title--commission'],
            'vc-text-m',
          )}
        >
          {t('PRICING_CALCULATOR.INFO.COMMISSION.TITLE')}
        </div>
        <div className={styles.learnMore__commission}>
          <div className={clsx(styles.learnMore__commission__price, styles['learnMore__commission__price--buyer'])}>
            <div className={styles.learnMore__commission__price__label}>
              {t('PRICING_CALCULATOR.INFO.COMMISSION.BUYER_PRICE')}
            </div>
            <p className={styles.learnMore__commission__price__price}>{buyerDisplayPrice}</p>
          </div>
          <div className={clsx(styles.learnMore__commission__price, styles['learnMore__commission__price--seller'])}>
            <div className={styles.learnMore__commission__price__label}>
              {t('PRICING_CALCULATOR.INFO.COMMISSION.SELLER_PRICE')}
            </div>
            <p className={styles.learnMore__commission__price__price}>{sellerDisplayPrice}</p>
          </div>
        </div>
      </section>
      <section className={styles.leanrMore__section}>
        <div className={clsx(styles.learnMore__section__title, 'vc-text-m')}>
          {t('PRICING_CALCULATOR.INFO.CONDITION.TITLE')}
        </div>
        <p className={clsx(styles.learnMore__section__intro, 'vc-text-m')}>
          {t('PRICING_CALCULATOR.INFO.CONDITION.NOTE')}
        </p>
        <ul className={clsx(styles.learnMore__condition, 'vc-text-m')}>
          <li className={styles.learnMore__condition__item}>
            <div className={styles.learnMore__condition__title}>{t('PRICING_CALCULATOR.INFO.CONDITION.NWT.TITLE')}</div>
            <p>{t('PRICING_CALCULATOR.INFO.CONDITION.NWT.DESCRIPTION')}</p>
          </li>
          <li className={styles.learnMore__condition__item}>
            <div className={styles.learnMore__condition__title}>
              {t('PRICING_CALCULATOR.INFO.CONDITION.NEVER_WORN.TITLE')}
            </div>
            <p>{t('PRICING_CALCULATOR.INFO.CONDITION.NEVER_WORN.DESCRIPTION')}</p>
          </li>
          <li className={styles.learnMore__condition__item}>
            <div className={styles.learnMore__condition__title}>
              {t('PRICING_CALCULATOR.INFO.CONDITION.VERY_GOOD.TITLE')}
            </div>
            <p>{t('PRICING_CALCULATOR.INFO.CONDITION.VERY_GOOD.DESCRIPTION')}</p>
          </li>
          <li className={styles.learnMore__condition__item}>
            <div className={styles.learnMore__condition__title}>
              {t('PRICING_CALCULATOR.INFO.CONDITION.GOOD.TITLE')}
            </div>
            <p>{t('PRICING_CALCULATOR.INFO.CONDITION.GOOD.DESCRIPTION')}</p>
          </li>
          <li className={styles.learnMore__condition__item}>
            <div className={styles.learnMore__condition__title}>
              {t('PRICING_CALCULATOR.INFO.CONDITION.FAIR.TITLE')}
            </div>
            <p>{t('PRICING_CALCULATOR.INFO.CONDITION.FAIR.DESCRIPTION')}</p>
          </li>
        </ul>
      </section>
    </div>
  );
};

export default LearnMoreModal;
